import { useContext, useEffect, useState } from "react";
import { AddProductsListToCartContext } from "../../../../widgets/providers/AddProductsListToCartContextProvider";
import { CartIcon } from "../../../../ui/General/CartIcon/CartIcon";
import { AccompanyingItem as AccompanyingItemType } from "./AccompanyingItem.interface";
import { useNavigate } from "react-router";

interface Props {
    totalPrice: number;
    selectedItems: AccompanyingItemType[];
    cartId: number;
    isCurrentInCart: boolean;
}

/**
 * Блок с информацией о стоимости комплекта
 * @param totalPrice - общая цена комплекта
 * @param selectedItems - количество выбранных товаров
 * @returns 
 */
export const AccompanyingItemsTotalBox = ({ totalPrice, selectedItems, cartId, isCurrentInCart }: Props) => {
    const { addProductsListToCart: addProductsListTocart } = useContext(AddProductsListToCartContext);
    const navigate = useNavigate();
    const [isAddedToCart, setIsAddedToCart] = useState(false);
    const [isAddedToCartLock, setIsAddedToCartLock] = useState(false);
    const count = isCurrentInCart ? selectedItems.length + 1 : selectedItems.length;

    //Сброс состояния добавления в корзину при изменении выбранных товаров
    useEffect(() => {
        let timer: NodeJS.Timeout;

        //Блокировка при обновлении выбранных товаров за счёт обновления корзины
        if (isAddedToCart && isAddedToCartLock) {
            //TODO: заменить на что-то более надёжное
            timer = setTimeout(() => {
                setIsAddedToCartLock(false);
            }, 1500);
        }

        //Сброс состояния добавления в корзину при отсутствии блокировки в момент добавления товара в список выбранных
        if (isAddedToCart && !isAddedToCartLock) {
            setIsAddedToCart(false);
        }

        return () => clearTimeout(timer);
    }, [selectedItems]);

    /** Добавление товаров в корзину */
    const addToCart = () => {
        addProductsListTocart(cartId, selectedItems.map(item => item.id));
        setIsAddedToCart(true);
        setIsAddedToCartLock(true);
    };

    return (
        <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg p-3 border border-orange-200 flex-shrink-0 flex flex-col gap-2">
            <p className="flex items-center gap-2">
                {/* <span className="text-xs text-gray-500 line-through">8 341 ₽</span> */}
                {/* <span className="bg-red-500 text-white text-xs px-1 py-0.5 rounded-full font-bold">-15%</span> */}
            </p>
            {/* <p className="text-xs text-gray-700 font-medium">Цена комплекта со скидкой:</p> */}
            <div className="flex items-center gap-2">
                <p className="font-bold text-lg text-gray-900">{totalPrice} ₽</p>
                <div className="flex flex-col">
                    {/* <p className="text-xs text-green-600 font-medium">Экономия: 1 251 ₽</p> */}
                    <p className="text-xs text-gray-600">({count} товаров)</p>
                </div>
            </div>
            {!isAddedToCart && <button onClick={addToCart}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 relative overflow-hidden duration-300 bg-orange-600 hover:bg-orange-700 text-white px-2 text-sm font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all">
                <div className="w-53 flex items-center gap-2 transition-all duration-300 scale-100 opacity-100">
                    <CartIcon />
                    <span>КУПИТЬ КОМПЛЕКТ ({count} ШТ.)</span>
                </div>
            </button>}
            {isAddedToCart && <button onClick={() => navigate("/cart")}
                className="w-53 flex justify-center items-center transition-all duration-300 scale-100 opacity-100 text-gray-900 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 relative overflow-hidden duration-300 bg-gray-200 px-2 text-sm font-semibold rounded-lg shadow-lg transition-all">
                Перейти в корзину
            </button>}
        </div>
    );
};